import React, { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import env from '@beam-australia/react-env';
import { SESSION_EXPIRED } from 'constants/routeConstants';
import { loggerFunc } from 'utils/logger';
import { ReleaseLockToken } from 'services/MyRacService';

const TimeoutWarningModal = () => {
  const [policyLockToken, setPolicyLockToken] = useOutletContext();
  const [isWarningModalOpen, setWarningModalOpen] = useState(false);

  const logger = loggerFunc('TimeoutWarning');

  const navigate = useNavigate();

  const unsetPolicyLockToken = async () => {
    try {
      const response = await ReleaseLockToken(policyLockToken);
      if (response?.payload) {
        setPolicyLockToken(null);
        logger.debug('Policy unlock successful');
      }
    } catch (error) {
      logger.debug(error);
    }
  };

  const forceLogout = () => {
    setWarningModalOpen(false);
    navigate(SESSION_EXPIRED, { state: { logoutAfterNavigate: true } });
  };

  useEffect(() => {
    const parsedTimeout = Number.parseInt(env('PAYMENT_SESSION_TIMEOUT'), 10);
    const paymentTimeout = Number.isFinite(parsedTimeout) ? parsedTimeout : 600000; // 10 minutes if env var is empty

    const tokenTimeout = setTimeout(async () => {
      if (policyLockToken) {
        await unsetPolicyLockToken();
      }
      setWarningModalOpen(true);
    }, paymentTimeout);

    return () => clearTimeout(tokenTimeout);
  }, [policyLockToken]);

  return (
    isWarningModalOpen && (
      <>
        <div className="modal myrac Modal__overflow din-font" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body text-center pt-5">
                <p>Your payment session has expired due to inactivity</p>
              </div>
              <div className="text-center pb-4">
                <button
                  className="MyRacForm__button"
                  data-dismiss="modal"
                  type="button"
                  onClick={forceLogout}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade in Modal__block" />
      </>
    )
  );
};

export default TimeoutWarningModal;
